<template>
    <div class="home">
        <el-container style="height: 100%;">
            <el-header style="height: 4%; display: flex;justify-content: space-between;">
                <div style="display: flex;gap:10px;">
                    <img src="../assets/favicon.png" alt="">
                    <div class="header-text-left">凌丰供应商系统</div>
                    <div class="pe-header-text">送货单明细</div>
                </div>

                <div style="width: 320px;">
                    <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                    <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
                </div>

            </el-header>

            <!-- main -->
            <el-main style="height: 94%;padding: 0;box-sizing: border-box;display: flex;flex-direction: column;">
                <div class="toolbar">
                    <el-button icon="el-icon-refresh" plain size="small" @click="senior_search">刷新</el-button>
                    <el-button icon="el-icon-printer" plain size="small" @click="handelPrint">打印发货单</el-button>
                </div>
                <div class="main-header">
                    <div style="line-height: 25px;font-size: 15px;margin-left: 20px;">送货单编号：{{
                        table_data.length ? table_data[0].formId : '' }}</div>
                    <div style="line-height: 25px;font-size: 15px;margin-left: 40px;">送货单状态：{{
                        table_data.length ? status_list[table_data[0].formStatus] : '' }}</div>
                    <div v-if="roleName != '供应商'" style="line-height: 25px;font-size: 15px;margin-left: 40px;">供应单位：{{
                        table_data.length ? table_data[0].supplier : '' }}
                    </div>
                    <div style="line-height: 25px;font-size: 15px;margin-left: 40px;">总金额：{{ totalPrice }}（元）</div>
                    <div style="line-height: 25px;font-size: 15px;margin-left: 40px;">制单时间：{{
                        table_data.length ? table_data[0].createTime : '' }}
                    </div>
                    <div v-if="table_data.length && table_data[0].finishTime"
                        style="line-height: 25px;font-size: 15px;margin-left: 40px;">
                        完成时间：{{ table_data.length ? table_data[0].finishTime : '' }}
                    </div>
                    <div v-if="table_data.length && table_data.find(item => item.deliveryAddress != null)"
                        style="line-height: 25px;font-size: 15px;margin-left: 40px;">
                        送货地址：{{table_data.length ? table_data.find(item => item.deliveryAddress !=
                            null).deliveryAddress :
                            ''
                        }}
                    </div>
                </div>
                <div class="table-body">
                    <el-table ref="multipleTable" :data="table_data" border height="100%"
                        :header-row-style="{ height: '0' }"
                        :header-cell-style="{ background: '#fff', color: '#000', padding: '0', textAlign: 'center' }"
                        :row-style="{ height: '0' }" :cell-style="{ padding: '2px 0' }" row-key="id"
                        v-loading="table_loading" @cell-dblclick="gen_doubleclick">
                        <!-- <el-table-column label="单号" prop="formId" width="270" align="center" sortable></el-table-column> -->
                        <el-table-column label="序号" width="50" prop="index" align="center">
                            <!-- <template slot-scope="{ $index }">
                                <span>{{ $index + 1 }}</span>
                            </template> -->
                        </el-table-column>
                        <el-table-column label="跟踪号" prop="projectName" width="220" align="center"
                            sortable></el-table-column>
                        <el-table-column label="合同号" prop="trackNumber" width="200" align="center"
                            sortable></el-table-column>
                        <el-table-column label="需用日期" prop="useDate" width="110" align="center"
                            sortable></el-table-column>
                        <el-table-column label="状态" width="95" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="status_color(scope.row)" size="mini" style="font-size: 14px;">{{
                                    status_list[scope.row.status]
                                }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="完成时间" prop="itemFinishTime" width="170" align="center"
                            sortable></el-table-column>
                        <!-- <el-table-column label="供应商" prop="supplier" width="240" align="center" sortable></el-table-column> -->
                        <el-table-column v-if="roleName != '供应商'" label="物料名称" prop="materialName" width="180"
                            align="center" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column v-if="roleName != '供应商'" label="物料类型" prop="materialType" width="180"
                            align="center" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column label="品名规格" prop="nameAlias" width="350" align="left" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.useAliasId && scope.row.nameAlias.length ?
                                        (scope.row.nameAlias.find(item
                                            => item.id ==
                                            scope.row.useAliasId)).name : scope.row.materialName + '--' + scope.row.materialType
                                    }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="送货地址" prop="deliveryAddress" width="200" align="left" sortable show-overflow-tooltip/> -->
                        <el-table-column label="备注" prop="itemRemark" width="200" align="left" sortable
                            show-overflow-tooltip />
                        <el-table-column label="物料编码" prop="materialBarcode" width="110" align="center"
                            sortable></el-table-column>
                        <el-table-column label="单位" prop="unit" width="75" align="center" sortable></el-table-column>
                        <el-table-column label="单价" prop="price" width="100" align="center" sortable></el-table-column>
                        <el-table-column label="金额" prop="totalPrice" width="100" align="center"
                            sortable></el-table-column>
                        <el-table-column label="数量" prop="outputNumber" width="150" align="center" sortable>
                            <template slot-scope="scope">
                                <el-input v-focus v-if="scope.row.outputNumber_show" clearable
                                    v-model="scope.row.outputNumber" size="mini"
                                    @keyup.enter.native="$event.target.blur()"
                                    @blur="onBlur(scope.row, scope.column)"></el-input>
                                <span v-else>{{ scope.row.outputNumber }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="签收" prop="receiveNumber" width="75" align="center"
                            sortable></el-table-column>
                        <el-table-column align="center" label="操作" width="60">
                            <template slot-scope="scope">
                                <el-button type="danger" plain circle icon="el-icon-delete" size="mini"
                                    @click="item_del(scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="table-footer">
                    <el-pagination background layout="sizes, prev, pager, next" :total="totalPage"
                        @size-change="handleSizeChange" @current-change="change_data"
                        :current-page="searchobj.currentPage" :page-size="searchobj.pageSize"
                        :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
                    </el-pagination>
                </div>
            </el-main>

            <!-- footer -->
            <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>
        </el-container>
    </div>
</template>

<script>
import *as sentFormApi from '@/Api/sentFormApi'
import *as buyPageApi from '@/Api/buyPageApi'
export default {
    name: 'sendPage_detail',
    components: {
    },
    data() {
        return {
            homeDate: '',
            userNme: sessionStorage.getItem('userName'),
            table_data: [],
            table_loading: false,
            searchobj: {
                pageSize: 30,
                currentPage: 1,
            },
            totalPage: 30,
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            status_list: ['未发货', '部分发货', '在途', '部分签收', '签收完成'],
            totalPrice: '',
            roleName: sessionStorage.getItem('roleName'),
        }
    },
    computed: {

    },
    methods: {
        //显示时间
        showTime() {
            setTimeout(() => {
                this.showTime();
            }, 1000);
            this.homeDate = this.$getTime()
        },
        //页码发生变化时
        change_data(e) {
            this.searchobj.currentPage = e
            this.senior_search()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.searchobj.pageSize = e
            this.searchobj.currentPage = 1
            this.senior_search()
        },
        //状态颜色
        status_color(row) {
            if (row.status == 0) return 'info'
            else if (row.status == 1 || row.status == 3) return 'warning'
            else if (row.status == 2) return ''
            else if (row.status == 4) return 'success'
        },


        //修改状态
        updateItemStatus(update_list) {
            buyPageApi.updateItemStatus(update_list, this).then(() => {
                this.senior_search()
            }).catch(() => { })
        },

        senior_search() {
            this.table_loading = true
            sentFormApi.sentFormQuery(this.searchobj, this).then(res => {
                res.records.forEach(item => {
                    item.outputNumber_show = false
                })
                this.table_data = res.records.map((item, index) => {
                    return {
                        ...item,
                        index: item.index !== null ? item.index : index + 1
                    }
                })
                this.table_data.sort((a, b) => a.index - b.index)
                this.totalPage = res.total
                sentFormApi.searchAllSentForm({ pageSize: 1, currentPage: 1, formId: this.table_data[0].formId }, this).then(res => {
                    this.totalPrice = res.records[0].totalPrice
                }).catch(() => { })
            }).catch(() => { }).finally(() => {
                this.table_loading = false
            })
        },

        change_blur(row, column) {
            if (column.property == 'nameAlias') {
                row.alias_show = false
                if (typeof this.select_alias === 'string') {
                    if (this.select_alias.trim() == '') return
                    else {
                        ///////添加别名//////////
                        let addname_obj = new Object()
                        addname_obj.id = row.id
                        addname_obj.materialId = row.materialId
                        addname_obj.supplierId = row.supplierId
                        addname_obj.nameAlias = [this.select_alias.trim()]
                        buyPageApi.addNameAlias(addname_obj, this)
                    }
                } else if (typeof this.select_alias === 'object') {
                    if (this.select_alias.id == row.useAliasId) return//选择了与之前一样的，不做处理
                    else {
                        ////////修改选择的别名/////////
                        let param = new Object()
                        param.id = row.id
                        param.anotherNameId = this.select_alias.id
                        buyPageApi.updateNameAlias(param, this)
                    }
                }
                this.select_alias = ''
                this.senior_search()
            }
            // this.send_update(row)
        },

        alias_blur(row, column) {
            if (column.property == 'nameAlias') {
                setTimeout(() => {
                    row.alias_show = false
                }, 100);
            }
        },

        //删除
        item_del(row) {
            if (row.status == 3 || row.status == 4) {
                this.$alert('该项数据已经存在签收内容，不能删除', '错误')
                return
            }
            this.$confirm('此操作将会删除该发货项', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let del_list = [row.id]
                sentFormApi.delSentForm(del_list, this).then(() => {
                    //////////////更新状态/////////////
                    if (this.table_data.length > 1) {
                        this.change_srm_formStatus()
                    }
                    this.senior_search()
                }).catch(() => { })
            }).catch(() => {
            });
        },

        //更新送货单表头状态
        change_srm_formStatus() {
            let form_status = {
                id: this.table_data[0].formId,
                formStatus: 4
            }
            sentFormApi.sentFormQuery({
                formId: this.table_data[0].formId,
                pageSize: 1000,
                currentPage: 1,
            }, this).then(res => {
                if (res.records.every(obj => obj.status === 4)) {
                    form_status.formStatus = 4;
                    form_status.finishTime = this.$getTime()
                } else if (res.records.every(obj => obj.status === 2)) {
                    form_status.formStatus = 2;
                } else form_status.formStatus = 3;

                // 开始更新
                sentFormApi.updateFormStatus(form_status, this)
            }).catch(() => { })
        },
        handelPrint() {
            //页面跳转
            const { href } = this.$router.resolve({
                path: '/printout',
                query: {
                    check_list: this.table_data[0].formId,
                    check_status: 2,
                }
            })
            window.open(href, '_blank')
        },
        gen_doubleclick(row, column) {
            if (column.property == 'outputNumber') {
                row.outputNumber_show = true
                this.tmp_quantity = row[column.property]
            }
        },
        onBlur(row) {
            row['outputNumber_show'] = false
            //状态校验
            if (row.status == 4 || row.status == 3) {
                this.$alert('有签收内容的项不能修改', '错误')
                row.outputNumber = this.tmp_quantity
                return
            }
            if (row.outputNumber == this.tmp_quantity) return
            //数字校验
            let res = /^[0-9]+(\.[0-9]+)?$/
            if (!res.test(row.outputNumber)) {
                this.$message({ type: "warning", message: "请输入数字" })
                row.outputNumber = this.tmp_quantity
                return
            }
            //数量校验
            if (row.outputNumber < row.receiveNumber || row.outputNumber == 0) {
                this.$alert("修改的数量大小异常", '错误')
                row.outputNumber = this.tmp_quantity
                return
            }
            //判空处理
            if (row.outputNumber == '') row.outputNumber = 0
            row.outputNumber = Number(row.outputNumber)
            this.send_update(row)
        },
        send_update(row) {
            let update_list = []
            let update_obj = new Object()
            update_obj.id = row.id
            update_obj.outputNumber = row.outputNumber
            if (row.receiveNumber == 0) update_obj.status = 2
            else update_obj.status = row.outputNumber == row.receiveNumber ? 4 : 3
            update_list.push(update_obj)
            sentFormApi.updateSentForm(update_list, this).then(() => {
                this.change_srm_formStatus()
                this.senior_search()
            }).catch(() => {
            })
        },


    },
    mounted() {
        this.showTime()
    },
    created() {
        if (this.$route.query.check_status == 1) {
            this.searchobj.formId = this.$route.query.check_list
            this.senior_search()
        }
    }
}
</script>
<style>
.home {
    height: 100%;
}

.el-header {
    background-color: #12b4bd;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover>td {
    background-color: #c0ddaf !important;
}

.table-body .selected-row {
    background-color: #c0ddaf;
}

.nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
    /* 使用transform缩放选择框 */
}

.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    /* z-index: 999 !important; */
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}

.home .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
}

.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}

.el-input--mini {
    font-size: 14px !important;
}
</style>
<style scoped>
.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.el-form-item {
    margin-bottom: 12px;
}

.main-header {
    height: 3%;
    background: linear-gradient(135deg, #0b9da5 0%, #67d674 100%);
    display: flex;
    align-items: center;
    color: #fff;
    padding: 0 20px;
    margin-top: 15px;
}

.main-header div {
    color: rgba(255, 255, 255, 0.95) !important;
}

.table-body {
    /* height: calc(100% - 52px); */
    flex: 1;
    padding: 0 15px 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.toolbar {
    background-color: #fff;
    padding: 10px 15px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.toolbar .el-button {
    transition: all 0.2s ease;
}

.toolbar .el-button:hover {
    transform: translateY(-2px);
}

.dialog-height::v-deep .el-table__body-wrapper {
    max-height: 65vh !important;
    overflow: scroll;
    padding-top: 0px;
}

.dialog-height::v-deep .el-dialog__body {
    padding: 20px !important;
}
</style>